// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-search-relation .inputSearch{
    background-color: #0166a0 !important;
}
.cont-search-relation .inputSearch:focus, .cont-search-relation .inputSearch:hover {
    
    color: aliceblue !important;
  }
.body_info_cis_relation {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .cont-cis-table-relation {
    position: relative;
    height: 90%;
    width: 100%;
    /* background: rgba(195,195,195);
    background: #003757; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-cis_relation {
    position: relative;
    justify-content: center;
    display: block;
    height: 98%;
    width: 94%;
    border-radius: 10px;
    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
    /* border: 2px solid #003757; */
    border-radius: 10px;
  }

  .cont-search-relation {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 35%;
  }
  
  .content-card-cis-relation {
    position: relative;
    height: 100%;
    width: 100%;
    display: block;
    justify-content: center;
    align-items: center;
    border: 1px solid #003757;
    border-radius: 10px;
  }

  .cont-elemen-relation{
    position: relative;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .elemen-relation{
    position: relative;
    width: 85%;
    height: 70%;
    border-radius: 10px;
    border:2px solid #003757;
    display: flex;

  }

  .con-elemen-relation-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 100%;
    color: #003757;
  }
  .con-elemen-relation-img{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10%;
    height: 100%;
  }
  .img-relation:hover{
    cursor: pointer;
  }
  .msgErrorRelation{
    color: red;
  }`, "",{"version":3,"sources":["webpack://./src/components/cis-components/styles/ModalCisAfecta.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;;IAEI,2BAA2B;EAC7B;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;0BACsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,2FAA2F;IAC3F,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ","sourcesContent":[".cont-search-relation .inputSearch{\r\n    background-color: #0166a0 !important;\r\n}\r\n.cont-search-relation .inputSearch:focus, .cont-search-relation .inputSearch:hover {\r\n    \r\n    color: aliceblue !important;\r\n  }\r\n.body_info_cis_relation {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .cont-cis-table-relation {\r\n    position: relative;\r\n    height: 90%;\r\n    width: 100%;\r\n    /* background: rgba(195,195,195);\r\n    background: #003757; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .content-cis_relation {\r\n    position: relative;\r\n    justify-content: center;\r\n    display: block;\r\n    height: 98%;\r\n    width: 94%;\r\n    border-radius: 10px;\r\n    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\r\n    /* border: 2px solid #003757; */\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cont-search-relation {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 35%;\r\n  }\r\n  \r\n  .content-card-cis-relation {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: 1px solid #003757;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cont-elemen-relation{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 60px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  }\r\n  .elemen-relation{\r\n    position: relative;\r\n    width: 85%;\r\n    height: 70%;\r\n    border-radius: 10px;\r\n    border:2px solid #003757;\r\n    display: flex;\r\n\r\n  }\r\n\r\n  .con-elemen-relation-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 90%;\r\n    height: 100%;\r\n    color: #003757;\r\n  }\r\n  .con-elemen-relation-img{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 10%;\r\n    height: 100%;\r\n  }\r\n  .img-relation:hover{\r\n    cursor: pointer;\r\n  }\r\n  .msgErrorRelation{\r\n    color: red;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
